import ModuleMixin from "../ModuleMixin";
import SnapshotModule from "../../../Snapshot/SnapshotModule/SnapshotModule.vue";
import SnapshotIcon from "../../../Snapshot/SnapshotIcon/SnapshotIcon.vue";
import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "Publizieren",
  components: {
    SnapshotModule,
    SnapshotIcon,
  },
  mixins: [
    ModuleMixin,
  ],
  computed: {
    optionsFormstepDetailLocal() {
      const OPTIONS = cloneDeep(this.optionsFormstepDetail);
      OPTIONS.list = [
        {
          id: "publizieren",
          htmlId: `${ this.htmlRegelNummer }_publizieren`,
          type: "boolean",
          label: "_LBL_GR_PUBLIZIEREN_",
          translate: true,
          required: true,
          view: "v-alt",
          editonly: true,
          startupFocus: true,
        },
      ];
      return OPTIONS;
    },

    labelHeader() {
      return this.modelParameter.frage;
    },

    statusDiff() {
      if (!this.snapshotModule) {
        return false;
      }
      return this.snapshotModule.publizieren !== this.model.publizieren;
    },
  },
  methods: {
    prepareModel() {
      this.model = cloneDeep(this.module.data) || {};
    },
  },
};
